import configs from "./configs";

export async function createShortID(initialSrc) {
  const prepareData = {
    src: initialSrc,
    ar: true,
    "ar-modes": "webxr scene-viewer quick-look",
    "camera-controls": true,
    "shadow-intensity": 1
  };

  const urlModel = `${configs["AR_EDITOR"]}/editor/view/?data=${encodeURI(JSON.stringify(prepareData))}`;

  const responseShorten = await fetch(`${configs["AR_API_SHORTENER"]}/shorten`, {
    method: "POST",
    body: JSON.stringify({ data: urlModel }),
    headers: {
      "Content-Type": "application/json"
    }
  });

  const { data: snippetCode } = await responseShorten.json();
  return snippetCode;
}

export async function updateARUrl(url, qrCodeId) {
  const prepareData = {
    src: url,
    ar: true,
    "ar-modes": "webxr scene-viewer quick-look",
    "camera-controls": true,
    "shadow-intensity": 1
  };

  const urlModel = `${configs["AR_EDITOR"]}/editor/view/?data=${encodeURI(JSON.stringify(prepareData))}`;
  const responseShorten = await fetch(`${configs["AR_API_SHORTENER"]}/${qrCodeId}`, {
    method: "PUT",
    body: JSON.stringify({ origUrl: urlModel }),
    headers: {
      "Content-Type": "application/json"
    }
  });

  await responseShorten.json();
  const arURL = `${configs["AR_EDITOR"]}/view/${qrCodeId}`;
  return arURL;
}
